import { Business, Business2, Business3 } from '@/entities/business';
import { ProductWithBusinessToList } from '@/entities/businessProduct';
import { useBusiness } from '@/hook/useBusiness';
import { BusinessService } from '@/services/BusinessService';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// business detail contex
interface IBusinessDetail {
  business: Business
}

const BusinessDetailContext = React.createContext<any>({} as IBusinessDetail);

export const BusinessDetailProvider: React.FC<any> = ({ children }) => {
  const leadId =  Number(useParams().leadId);
  const [business, setbusiness] = useState<Business>();
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [businessEdit, setBusinessEdit] = useState<Business2>();
  const [businessEdit2, setBusinessEdit2] = useState<Business3>();
  const [businessProducts, setBusinessProducts] = useState<ProductWithBusinessToList[]>([]);

  // const { business } = usebusiness(leadId);

  useEffect(() => {
    fetchbusinessById();
  }, [leadId]);

  const fetchbusinessById = async () => {
    if (!leadId) return;
    const response = await BusinessService.getBusinessById(leadId);
    // console.log(response);
    if (response){
      const n = {
        idnegocio: response.id,
        client: response.client,
        indicators: response.businessIndicators,
        descricao: response.description,
        email: response? response.email : '',
        idfluxodeoportunidade: response.opportunityFlowId,
        idfontenegocio: response.businessSource? response.businessSource.id : 0,
        idtiponegocio: response.activityTypes ? response.activityTypes.id : 0,
        dtcadastro: response ? response.createdAt : undefined,
        dtinicio: response ? response.startedAt : undefined,
        dtfechamento: response ? response.closedAt : undefined,
        previsao: response ? response.prevision : undefined,
        situacao: response ? response.status : 0,
        total: 0,
        motivo: response.reason,
        observacao: response.observation,
        feedback: '',
        idindicador: 0,
        tel: response ? response.contactNumber : '',
      };
      // console.log(n);
      setBusinessEdit2({...n}); 
      setBusinessEdit(response);
      setbusiness(response);
    }
  };

  return (
    <BusinessDetailContext.Provider value={{ business, deleteOpen, businessEdit, businessProducts, businessEdit2, setBusinessEdit2, setBusinessEdit, setBusinessProducts, setDeleteOpen, fetchbusinessById, setbusiness }}>
      {children}
    </BusinessDetailContext.Provider>
  );
};

export const useBusinessDetailContext = () => React.useContext(BusinessDetailContext);
